<template>
  <div class="h-[60px] overflow-hidden bg-white shadow-sm border-b border-slate-100 relative flex items-center justify-between px-0 z-50">
    
    <div class="flex items-center h-full">
      <hamburger
        id="hamburger-container"
        :is-active="appStore.sidebar.opened"
        class="h-full px-4 flex items-center cursor-pointer hover:bg-slate-50 transition-colors duration-200 tap-transparent"
        @toggleClick="toggleSideBar"
      />
      
      <breadcrumb 
        v-if="!settingsStore.topNav" 
        id="breadcrumb-container" 
        class="ml-2" 
      />
      
      <top-nav 
        v-if="settingsStore.topNav" 
        id="topmenu-container" 
        class="ml-2" 
      />
    </div>

    <div class="flex items-center h-full pr-6">
      <template v-if="appStore.device !== 'mobile'">
        <header-search 
          id="header-search" 
          class="flex items-center justify-center h-full px-3 text-slate-500 hover:bg-slate-50 transition-colors cursor-pointer rounded-md" 
        />

        <screenfull 
          id="screenfull" 
          class="flex items-center justify-center h-full px-3 text-slate-500 hover:bg-slate-50 transition-colors cursor-pointer rounded-md" 
        />

        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select 
            id="size-select" 
            class="flex items-center justify-center h-full px-3 text-slate-500 hover:bg-slate-50 transition-colors cursor-pointer rounded-md" 
          />
        </el-tooltip>
      </template>

      <div class="ml-2">
        <el-dropdown @command="handleCommand" trigger="click">
          <div class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-slate-50 cursor-pointer transition-all duration-200 border border-transparent hover:border-slate-100">
            <div class="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-medium shadow-sm shrink-0">
              {{ userStore.name?.charAt(0).toUpperCase() || 'A' }}
            </div>
            
            <div class="flex flex-col items-start">
              <span class="text-sm font-medium text-slate-700 leading-tight">
                {{ userStore.name || 'Admin' }}
              </span>
              <!-- <span class="text-xs text-slate-400 leading-tight mt-0.5">
                {{ userStore.email || 'admin@example.com' }}
              </span> -->
            </div>

            <el-icon class="text-slate-400 text-xs ml-1"><CaretBottom /></el-icon>
          </div>

          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item command="setLayout" v-if="settingsStore.showSettings">
                <span>布局设置</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <span class="text-red-500">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus'
import { CaretBottom } from '@element-plus/icons-vue' // 确保引入图标
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import HeaderSearch from '@/components/HeaderSearch'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'

const appStore = useAppStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()

function toggleSideBar() {
  appStore.toggleSideBar()
}

function handleCommand(command) {
  switch (command) {
    case 'setLayout':
      setLayout()
      break
    case 'logout':
      logout()
      break
    default:
      break
  }
}

function logout() {
  ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      userStore.logOut().then(() => {
        // 退出后整页刷新，守卫会重定向到登录页，路径无关
        location.reload()
      })
    })
    .catch(() => {})
}

const emits = defineEmits(['setLayout'])
function setLayout() {
  emits('setLayout')
}
</script>